import { Editor, useEditorState } from '@tiptap/react'
import { Select } from 'antd'

import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

type Props = {
  editor: Editor
}

const fontFamilyOptions = [
  { label: 'Sans Serif', value: 'sans-serif' },
  { label: 'Serif', value: 'serif' },
  { label: 'Monospace', value: 'monospace' }
]

export const FontFamilySelect = ({ editor }: Props) => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      const { state } = ctx.editor
      const { selection } = state
      const marks = state.storedMarks || selection.$from.marks()

      const textStyleMark = marks.find((mark) => mark.type.name === 'textStyle')
      const currentFontFamily =
        (textStyleMark?.attrs?.fontFamily as string) || 'sans-serif'

      return {
        fontFamily: currentFontFamily
      }
    }
  })

  const onFontFamilyChange = (value: string) => {
    if (value === 'sans-serif') {
      editor.chain().focus().unsetFontFamily().run()
    } else {
      editor.chain().focus().setFontFamily(value).run()
    }
  }

  return (
    <Select
      value={editorState.fontFamily}
      options={fontFamilyOptions}
      onChange={onFontFamilyChange}
      className={styles.fontFamilySelect}
      placeholder={t('editor.font_family')}
    />
  )
}
